<template>
  <div>
    <b-button size="sm" class="mb-3" variant="outline-primary" @click="addItem"
      >Add
    </b-button>
    <b-list-group>
      <b-list-group-item
        v-for="item in items"
        :key="item.id"
        class="dashboard-list-item"
        size="sm"
      >
        <b-row>
          <b-col>
            {{ item.id }}
          </b-col>
          <b-col cols="1">
            <b-icon-trash
              variant="danger"
              style="cursor: pointer"
              @click="deleteItem(item.id)"
            />
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>

    <b-modal
      v-model="formModal"
      centered
      hide-header
      size="lg"
      button-size="sm"
      ok-title="Submit"
      @ok="submit"
    >
      <b-form ref="main-form">
        <b-row>
          <b-col cols="3">
            Brand Market
          </b-col>
          <b-col>
            <b-form-input
              required
              v-model="formItems.id"
              size="sm"
              placeholder="F1M1"
            />
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import notification from '@/mixins/notification';
import adminServices from '../../services/adminServices';

export default {
  name: 'BrandsMarkets',
  mixins: [notification],
  mounted() {
    this.getList();
  },
  computed: {
    filteredLevels() {
      const searchText = this.searchText.toLowerCase();
      let filteredLevels = _.filter(this.levels, { cubeConfigId: this.cubeId });
      filteredLevels = _.filter(filteredLevels, level => {
        return level.levelId.toLowerCase().includes(searchText);
      });
      return filteredLevels;
    },
  },
  data() {
    return {
      items: [],
      formItems: defaultFormItems(),
      searchText: '',
      formModal: false,
      isEdit: false,
    };
  },
  methods: {
    getList() {
      adminServices.getBrandsMarkets().then(resp => {
        this.items = resp.data;
      });
    },
    addItem() {
      this.formItems = defaultFormItems();
      this.formModal = true;
    },
    deleteItem(id) {
      this.$bvModal
        .msgBoxConfirm('Proceed to delete Brand Market?', { centered: true })
        .then(value => {
          if (value) {
            this.formModal = false;
            adminServices.deleteBrandsMarkets(id).then(() => {
              this.PromptSuccess(
                'Success',
                'Brand Market had been deleted successfully.'
              );
              this.items = _.filter(this.items, item => item.id !== id);
            });
          }
        });
    },
    submit(e) {
      e.preventDefault();
      const mainForm = this.$refs['main-form'];
      if (!mainForm.reportValidity()) {
        return;
      }
      const id = this.formItems.id;
      const formItems = { id: id, name: id };

      this.$bvModal
        .msgBoxConfirm('Proceed to add Brand Market?', { centered: true })
        .then(value => {
          if (value) {
            this.formModal = false;
            adminServices.postBrandsMarkets(formItems).then(resp => {
              this.PromptSuccess(
                'Success',
                'Brand Market had been added successfully.'
              );
              this.items.push(resp.data);
            });
          }
        });
    },
  },
};

const defaultFormItems = () => {
  return {
    id: '',
    name: '',
  };
};
</script>

<style scoped>
.dashboard-list-item:hover {
  background-color: #ebebeb;
}
</style>